import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.manage.integration', {
        url: '/integration',
        component: 'companyIdpAuthenticatorsManageIntegration',
        resolve: {
        },

    });
}





// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/integration/idp-authenticator-integration.state.js